"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequenceMap = exports.SeqTrieNode = void 0;
const util_1 = require("./util");
class SeqTrieNode {
    constructor(children, bindings) {
        this.children = children;
        this.bindings = bindings;
    }
}
exports.SeqTrieNode = SeqTrieNode;
class SequenceMap {
    constructor() {
        this.root = new SeqTrieNode(new Map());
        /** Length of the longest registered sequence (number of steps). */
        this.maxDepth = 0;
    }
    set(sig, action, options) {
        const steps = sig.split(' ').map((s) => (0, util_1.expandMod)(s));
        let node = this.root;
        for (const step of steps) {
            let child = node.children.get(step);
            if (!child) {
                child = new SeqTrieNode(new Map());
                node.children.set(step, child);
            }
            node = child;
        }
        const binding = { ...options, sig, action };
        (node.bindings ?? (node.bindings = [])).push(binding);
        if (steps.length > this.maxDepth)
            this.maxDepth = steps.length;
    }
    del(sig, action) {
        const steps = sig.split(' ').map((s) => (0, util_1.expandMod)(s));
        let node = this.root;
        for (const step of steps) {
            const child = node.children.get(step);
            if (!child)
                return;
            node = child;
        }
        if (!node.bindings)
            return;
        const idx = node.bindings.findIndex((b) => b.action === action);
        if (idx !== -1)
            node.bindings.splice(idx, 1);
        // Note: prefix set rebuild on delete is omitted for simplicity;
        // prefixes are conservative (may contain stale entries — harmless).
    }
    isEmpty() {
        return this.root.children.size === 0;
    }
}
exports.SequenceMap = SequenceMap;
